export default {
  title: 'DISPATCH NOTIFICATION SETTINGS', 
  items: {
    DispatchWarningMins: {
      label: 'Warning - Minutes Before Pickup',
      type: 'integer',
      unit: 'minutes'
    },
    DispatchCriticalMins: {
      label: 'Critical - Minutes Before Pickup',
      type: 'integer',
      unit: 'minutes'
    },
    DispatchCriticalSms: {
      label: 'Critical - Phones to Notify via SMS',
      type: 'string',
      unit: 'phone (comma-separated)'
    },
    DispatchLateWarningMins: {
      label: 'Driver Late Warning - Minutes Before Pickup',
      type: 'integer',
      unit: 'minutes'
    },
    DispatchLateCriticalMins: {
      label: 'Driver Late Critical - Minutes Before Pickup',
      type: 'integer',
      unit: 'minutes'
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/Settings/settings-config/dispatch-notification-settings.js